// const apiAddress = 'https://torsedor.md/';
const apiAddress = window.location.origin + '/';

export {apiAddress};